import React from 'react';
import { FaSpinner, FaDatabase, FaArchive } from 'react-icons/fa';

const LoadingOverlay = ({ isVisible, message = 'Processing...', subMessage = '', type = 'default' }) => {
  if (!isVisible) return null;

  // Icon based on type
  const getIcon = () => {
    if (message.toLowerCase().includes('database')) {
      return <FaDatabase className="text-5xl text-[#3899cf]" />;
    } else if (message.toLowerCase().includes('project')) {
      return <FaArchive className="text-5xl text-green-600" />;
    }
    return null;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full mx-4 transform transition-all">
        <div className="flex flex-col items-center">
          {/* ✅ Fixed Animated Spinner */}
          <div className="relative mb-6">
            {/* Outer rotating ring */}
            <div className="w-24 h-24 border-4 border-gray-200 rounded-full"></div>
            
            {/* Spinning border */}
            <div className="absolute top-0 left-0 w-24 h-24 border-4 border-[#3899cf] border-t-transparent rounded-full animate-spin"></div>
            
            {/* Inner icon */}
            <div className="absolute inset-0 flex items-center justify-center">
              {getIcon() || <FaSpinner className="text-4xl text-[#3899cf] animate-pulse" />}
            </div>
          </div>

          {/* Main Message */}
          <h3 className="text-xl font-semibold text-gray-800 mb-2 text-center">
            {message}
          </h3>

          {/* Sub Message */}
          {subMessage && (
            <p className="text-sm text-gray-600 text-center mb-4">
              {subMessage}
            </p>
          )}

          {/* Progress Dots */}
          <div className="flex space-x-2 mt-4">
            <div className="w-3 h-3 bg-[#3899cf] rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-3 h-3 bg-[#3899cf] rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-3 h-3 bg-[#3899cf] rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>

          {/* Additional Info */}
          <p className="text-xs text-gray-500 mt-6 text-center">
            Please wait, do not close this window...
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
